import { createFileRoute } from '@tanstack/react-router'
import { useTracking } from '@vgw/multibrand-fe-tracking'
import { useBrandFeatures } from '@/lib/use-brand-features'
import { HeroBanner } from '@/features/hero-banner/hero-banner'
import { Lobby } from '@/features/lobby/lobby'
import { LobbyRootLayout } from '../../-lobby-root-layout'
import { useOidc } from '@/features/oidc/oidc'
import { assertCanPlayBeforeLoad } from '@/features/ctrls-and-caps/assert-can-play-before-load'
import { useEffect } from 'react'
import { useWalletStore } from '@/features/wallet-store/use-wallet-store'
import { useCheckForDeferredInAppMessage } from '@/features/braze/use-check-for-deferred-in-app-message'

export const Route = createFileRoute('/_app/')({
  component: Home,
  beforeLoad: async ({ context }) => {
    return assertCanPlayBeforeLoad(context.queryClient)
  },
})

let renderedOnce = false

function Home() {
  const { track } = useTracking()
  const { isNewBrowserSession } = useOidc({ assert: 'user logged in' })
  const brandFeatures = useBrandFeatures()
  const tokenType = useWalletStore((state) => state.coinType)
  useCheckForDeferredInAppMessage()

  useEffect(() => {
    const isFirstViewInNewUserSession = isNewBrowserSession && !renderedOnce

    track('Lobby Page Loaded', {
      eventData: {
        'page trigger': isFirstViewInNewUserSession
          ? 'login completed'
          : 'other',
        'token type': tokenType,
      },
    })

    renderedOnce = true
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <LobbyRootLayout>
      <div className="w-full">
        <div className="overflow-x-clip xl:px-4">
          {brandFeatures.isHeroBannerEnabled ? (
            <HeroBanner
              page={undefined}
              placement="hero_banner"
              pageType="lobby"
            />
          ) : null}
        </div>
        <div data-chromatic="ignore">
          <Lobby />
        </div>
      </div>
    </LobbyRootLayout>
  )
}
